import { useMemo } from "react";
import { motion } from "framer-motion";

// Atmospheric particle field themed per world.
// variants: bokeh, stars, embers, steam, sparkles, rain
export const Particles = ({ variant = "stars", color = "#9FE8FF", count }) => {
  const n = count || (variant === "rain" ? 44 : variant === "bokeh" ? 14 : 26);
  const items = useMemo(
    () =>
      Array.from({ length: n }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        top: Math.random() * 100,
        delay: Math.random() * 6,
        r: Math.random(),
      })),
    [n, variant] // eslint-disable-line react-hooks/exhaustive-deps
  );

  if (variant === "rain") {
    return (
      <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
        {items.map((p) => (
          <motion.span
            key={p.id}
            className="absolute"
            style={{
              left: `${p.left}%`,
              width: 1.5,
              height: 14 + p.r * 18,
              background: `linear-gradient(${color}, transparent)`,
              opacity: 0.2 + p.r * 0.4,
            }}
            initial={{ y: "-12%" }}
            animate={{ y: "118vh" }}
            transition={{ duration: 0.6 + p.r * 0.9, delay: p.delay % 2, repeat: Infinity, ease: "linear" }}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {items.map((p) => {
        const blob = variant === "bokeh" || variant === "steam";
        const twinkle = variant === "stars" || variant === "sparkles";
        const size = blob ? 16 + p.r * 50 : variant === "embers" ? 3 + p.r * 6 : 2 + p.r * 4;
        const rise =
          variant === "embers" ? -150 : variant === "steam" ? -130 : variant === "bokeh" ? 30 : 0;
        const drift = (p.r - 0.5) * 70;
        const dur = 6 + p.r * 10;
        const op = variant === "bokeh" ? 0.12 + p.r * 0.22 : variant === "steam" ? 0.05 + p.r * 0.12 : 0.3 + p.r * 0.6;
        return (
          <motion.span
            key={p.id}
            className="absolute rounded-full"
            style={{
              width: size,
              height: size,
              left: `${p.left}%`,
              top: `${p.top}%`,
              background: blob
                ? `radial-gradient(circle, ${variant === "steam" ? "#ffffff" : color} 0%, transparent 70%)`
                : color,
              boxShadow:
                variant === "sparkles"
                  ? `0 0 10px ${color}`
                  : variant === "stars"
                  ? `0 0 6px ${color}`
                  : variant === "embers"
                  ? `0 0 12px ${color}`
                  : "none",
              filter: blob ? "blur(3px)" : "none",
            }}
            initial={{ opacity: 0 }}
            animate={{
              opacity: [0, op, op, 0],
              y: [0, rise],
              x: [0, drift],
              scale: twinkle ? [0.5, 1.3, 0.5] : [1, 1.1, 1],
            }}
            transition={{ duration: dur, delay: p.delay, repeat: Infinity, ease: "easeInOut" }}
          />
        );
      })}
    </div>
  );
};

export default Particles;
